import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

import './TaxRules.css';

const propTypes = {
  id: PropTypes.string.isRequired,
  close: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired
};

class TaxRules extends React.Component {
  render() {
    return (
      <Modal
        id={`component-TaxRules-${this.props.id}`}
        show={this.props.showModal}
        onHide={this.props.close}
        bsSize="large">
        <Modal.Header closeButton bsClass="taxRulesHeader">
          <Modal.Title>
            TERMOS E CONDIÇÕES DO PROGRAMA DE VANTAGENS AZUL FIDELIDADE PARA EMISSÕES INTERLINE
          </Modal.Title>
        </Modal.Header>

        <Modal.Body bsClass="taxRulesBody">{this.renderRules()}</Modal.Body>
      </Modal>
    );
  }

  renderRules() {
    return (
      <span className="TaxRules">
        <p>
          A <strong>AZUL LINHAS AÉREAS BRASILEIRAS S.A.</strong>, sociedade anônima regularmente
          constituída no país, inscrita no CNPJ/MF sob nº 09.296.295/0001-60, com sede na Avenida
          Marcos Penteado de Ulhôa Rodrigues, nº 989, Edifício Jatobá, 9º andar, Tamboré, na Cidade
          de Barueri, Estado de São Paulo, CEP 06456-040 (“
          <strong>AZUL</strong>
          ”) desenvolveu e mantém o Programa de Vantagens Azul Fidelidade (“
          <strong>AZUL FIDELIDADE</strong>" ou “<u>Programa</u>
          ”) para reconhecer e recompensar seus clientes por utilizarem seus produtos e serviços (“
          <u>Participantes</u>
          ”). O regulamento do AZUL FIDELIDADE é público e cabe ao Participante tomar conhecimento dos seus
          termos e condições para decidir sobre sua adesão ao Programa.
        </p>
        <p>
          Poderão participar de forma gratuita no Programa as pessoas físicas que tiverem mais de 2
          (dois) anos de idade e forem titulares de Conta Azul Fidelidade dentro do período de vigência do
          Programa. Participantes menores de 18 (dezoito) anos e, portanto, civilmente incapazes de
          acordo com a legislação brasileira, deverão ler e aceitar o presente Regulamento
          assistidos ou representados por seus pais ou representantes legais.
        </p>
        <p>
          A adesão ao Programa permitirá ao Participante usufruir dos benefícios e vantagens do
          AZUL FIDELIDADE e dependerá de sua ciência e concordância com relação a todas as regras e
          condições estipuladas no presente Termos e Condições do Programa de Vantagens Azul Fidelidade
          para Emissões Interline (“
          <u>Termo</u>
          ”).
        </p>
        <p>
          <strong>CONSIDERANDO QUE:</strong>
        </p>
        <p>
          <ol type="a">
            <li>
              a AZUL é a administradora do Programa o qual possibilita o resgate de bilhetes aéreos
              ou comprovante de passagem aérea, que pode ser emitido por meio físico ou eletrônico
              ("
              <u>Bilhete</u>
              "), conforme abaixo definido, utilizando pontos AZUL FIDELIDADE;
            </li>
            <li>
              O AZUL FIDELIDADE disponibiliza em seus canais de resgate uma ferramenta de pesquisa e
              aquisição de Bilhetes Aéreos de Companhias Aéreas, conforme abaixo definido, a partir
              das informações que são inseridas para busca em seu site pelo Participante do
              Programa, por exemplo, mas não se limitando, (i) cidade de origem, (ii) cidade de
              destino, (iii) data da ida, (iv) data da volta, (v) horário da ida, (vi) horário da
              volta, (vii) quantidade de adultos e (viii) quantidade de crianças;
            </li>
            <li>
              O AZUL FIDELIDADE atua como intermediário entre o Participante e as Companhias Aéreas que
              efetivamente operarão os voos para disponibilização de Bilhetes Aéreos mediante a
              utilização de Pontos AZUL FIDELIDADE, de acordo com a modalidade de tarifa escolhida; e
            </li>
            <li>
              O usuário do serviço de transporte aéreo (“
              <u>Passageiro</u>
              ”) que adquirir um Bilhete concorda expressamente com as disposições contidas neste
              Termo, no Regulamento do Programa Azul Fidelidade e no Contrato de Transporte Aéreo da
              Companhia que operará o voo.
            </li>
          </ol>
        </p>
        <p id="rules">
          <ol>
            <li>
              <strong>RESGATES AÉREOS</strong>
              <p>
                Para emissão do Bilhete, o Participante deverá (i) estar com a sua Conta AZUL FIDELIDADE
                regular e devidamente atualizada, (ii) possuir acesso a sua Conta no website do
                AZUL FIDELIDADE ou canais disponibilizados; (iii) possuir a quantidade de Pontos necessária
                para a emissão do Bilhete Aéreo; (iv) efetuar o pagamento de eventuais taxas, bem
                como deverá existir disponibilidade da tarifa desejada para emissão.
              </p>
              <p>
                O Participante deve tomar conhecimento das regras tarifárias dos Bilhetes que
                pretende emitir e do conteúdo do Contrato de Transporte Aéreo que será
                disponibilizado pela Companhia Aérea no momento da emissão do Bilhete. Após a
                emissão do Bilhete, em caso de dúvidas, o Participante poderá obter informações
                através da Central de Atendimento (11) 4003-3255 ou 0800 887 1118.
              </p>
              <p>
                O Bilhete é a expressão do Contrato de Transporte Aéreo, firmado exclusivamente
                entre o Passageiro e a Empresa de Transporte Aéreo, sendo, portanto, regido pelas
                normas nacionais e internacionais específicas e, também, pelo Código Brasileiro de
                Aeronáutica e Código de Defesa do Consumidor.
              </p>
              <p>
                Os Bilhetes poderão ser emitidos para viagens de ida ou ida e volta, não serão
                permitidas emissões com múltiplos trechos ou paradas (stopovers).
              </p>
            </li>
            <li>
              <strong>DAS REGRAS TARIFÁRIAS E DA IMPOSSIBILIDADE DE TRANSFERÊNCIA</strong>
              <p>
                O Bilhete é pessoal e intransferível, nem mesmo por endosso, destinado
                exclusivamente ao transporte do Passageiro lá indicado, estando sujeito às regras
                aplicáveis, inclusive quanto a cancelamento, reembolso e alteração. As restrições e
                penalidades aplicáveis ao Bilhete estão disponíveis no momento da compra e mediante
                consulta das regras tarifárias por meio{' '}
                <a href="https://interline.tudoazul.com/">interline.tudoazul.com</a>.
              </p>
              <p>
                O Participante deverá preencher os dados pessoais do efetivo Passageiro no ato da
                reserva de forma correta.
              </p>
              <p>
                Em caso de qualquer incorreção das informações de identificação do Passageiro
                constantes no Bilhete, correspondentes a seu nome, sobrenome ou agnome, o Passageiro
                deverá entrar em contato com a Central de Atendimento e solicitar a correção até o
                momento do check-in, mas preferencialmente em até 24 (vinte e quatro) horas do
                check-in, as correções deverão ser autorizadas pela Companhia Aérea operadora do voo
                e o Bilhete estará sujeito a alterações de datas e horários conforme a
                disponibilidade do operador, sendo certo que eventuais custos poderão ser repassados
                ao Passageiro.
              </p>
              <p>
                A possibilidade de correção das informações indicadas na cláusula acima não retira o
                caráter individual do Bilhete, não podendo, em hipótese alguma, nos termos da
                legislação brasileira, as informações nele inseridas serem alteradas para o nome de
                terceiro.
              </p>
              <p>
                Eventuais alterações nas informações de identificação constantes do Bilhete poderão
                depender da verificação presencial de documentos de identificação pela Companhia
                Aérea, por razões de segurança.
              </p>
            </li>
            <li>
              <strong>DA VALIDADE DO BILHETE</strong>
              <p>A validade do Bilhete será estabelecida pela Companhia Aérea operadora do voo. </p>
            </li>
            <li>
              <strong>DA CONFIRMAÇÃO DA RESERVA</strong>
              <p>
                A reserva será considerada “confirmada” apenas com a efetivação do débito de pontos
                da conta AZUL FIDELIDADE e validação do pagamento das taxas devidas.
              </p>
              <p>
                O Participante efetuará o pagamento das taxas de embarque por meio de cartão de
                crédito. Contudo, mesmo após o recebimento da confirmação de sua reserva, a AZUL
                realizará avaliação cadastral do Participante e constatada divergência de dados,
                pedido posterior de reembolso por parte do banco emissor do cartão de crédito ou
                eventual fraude por descumprimento às regras do Programa AZUL FIDELIDADE, tal reserva será
                automaticamente cancelada, bem como o valor e os Pontos serão automaticamente
                reembolsados através do mesmo meio de pagamento utilizado para compra.
              </p>
            </li>
            <li>
              <strong>ALTERAÇÕES E RESILIÇÕES POR PARTE DO PARTICIPANTE</strong>
              <ol>
                <li>
                  <strong>Alterações</strong> - Não serão permitidas quaisquer alterações no Bilhete
                  Aéreo emitido referente ao itinerário ou horário da reserva já contratada.
                </li>
                <li>
                  <strong>Cancelamento e Reembolso</strong> - Entende-se por cancelamento a
                  desistência da viagem e/ou do serviço contratado.
                  <p>
                    Permitido somente cancelamento integral de todos os Passageiros e trechos da
                    reserva, desde que estejam válidos e nenhum trecho tenha sido utilizado. Serão
                    aplicadas as penalidades e restrições vigentes no momento da compra que serão
                    disponibilizadas no momento do resgate da passagem no website{' '}
                    <a href="https://interline.tudoazul.com/">interline.tudoazul.com</a>
                  </p>
                  <p>
                    <strong>Bilhete reembolsável</strong> – será permitido o reembolso do Bilhete
                    somente quando (i) Bilhete válido e não utilizado (ii) houver previsão para tal
                    nas regras tarifárias da Companhia Aérea e (iii) constar esta informação
                    expressa no website{' '}
                    <a href="https://interline.tudoazul.com/">interline.tudoazul.com</a>
                  </p>
                  <p>
                    <strong>Bilhete não reembolsável (restrito)</strong> – será permitido o
                    reembolso apenas da taxa de embarque no mesmo cartão de crédito utilizado para o
                    pagamento, quando solicitado pelo Passageiro ao AZUL FIDELIDADE através da Central de
                    Atendimento (11) 4003-3255 ou 0800 887 1118.
                  </p>
                  <p>
                    Somente os Pontos AZUL FIDELIDADE utilizados para a compra do “bilhete reembolsável”
                    serão estornados mediante crédito na conta do titular do Programa com a validade
                    original mantida. A utilização de Pontos AZUL FIDELIDADE para emissão de Bilhetes não
                    interrompe ou suspende o prazo de validade dos Pontos.
                  </p>
                  <p>
                    Quando da solicitação de reembolso do Bilhete, o Participante deverá solicitar o
                    reembolso da taxa de embarque, e o mesmo será efetuado respeitando o meio de
                    pagamento utilizado para adimplemento da referida taxa.
                  </p>
                </li>
                <li>
                  <strong>Do não comparecimento ao voo - No-show</strong> - Em caso de não
                  comparecimento do Passageiro para o embarque com a antecedência estabelecida pela
                  Companhia Aérea operadora do voo em qualquer das etapas, serão aplicadas as regras
                  da tarifa não reembolsável.
                </li>
              </ol>
            </li>
            <li>
              <strong>MARCAÇÃO DE ASSENTO</strong>
              <p>
                O Participante deverá entrar em contato com a Companhia Aérea operadora do voo para
                marcação de assento.
              </p>
            </li>
            <li>
              <strong>BAGAGEM DE MÃO, DESPACHADA, TRANSPORTE DE ARMA DE FOGO</strong>
              <p>
                O transporte será feito de acordo com o critério da Companhia Aérea operadora do
                voo, razão pela qual o Participante/Passageiro deverá se informar diretamente com
                Companhia Aérea operadora do voo sobre as restrições, franquias, pesos dimensões.
              </p>
              <p>
                Quaisquer danos decorrentes da prestação de serviço de transporte de bagagem deverão
                ser comunicados pelo Passageiro diretamente à Companhia Aérea operadora do voo,
                sendo esta a única e exclusiva responsável por qualquer indenização.
              </p>
            </li>
            <li>
              <strong>SERVIÇOS E ASSISTÊNCIAS ESPECIAIS</strong>
              <p>
                O Participante deverá entrar em contato com a Companhia Aérea operadora do voo para
                contratar serviços especiais, tais como refeições especiais, compra de bagagem,
                transporte de animais, transporte de bagagens especiais e etc., bem como obter
                informações sobre o serviço de menor desacompanhado, serviço de acompanhamento de
                PNAE (pessoa com deficiência, pessoa com idade igual ou superior à sessenta anos,
                gestante, lactante, pessoa acompanhada por criança de colo, pessoa com mobilidade
                reduzida ou qualquer pessoa que por alguma condição específica tenha limitação na
                sua autonomia como Passageiro), transporte de cão de apoio emocional, transporte de
                cão-guia, transporte de PNAE ou qualquer informação sobre formulários que devem ser
                preenchidos para obtenção da autorização de transporte de Passageiros.
              </p>
            </li>
            <li>
              <strong>RESPONSABILIDADES DO PASSAGEIRO</strong>
              <p>
                O Passageiro deverá, sob sua exclusiva responsabilidade apresentar-se para check-in,
                despacho de bagagem e embarque dentro do limite de horário estabelecido pela
                Companhia Aérea operadora do voo, portando os documentos de viagem necessários,
                devendo, para tanto, verificar as respectivas regras no website da Companhia Aérea,
                Contrato de Transporte Aéreo ou outros canais de atendimento ao cliente.
              </p>
              <p>
                Documentos de viagem, tais como, mas não exclusivamente, documentos pessoais,
                vistos, vacinas, autorizações de viagem e etc., são de total e exclusiva
                responsabilidade do Passageiro.
              </p>
              <p>
                O Participante deverá cumprir com as leis de seu país de origem e de cada país a ser
                visitado, bem como entrar em contato com a Companhia Aérea operadora do voo para
                demais informações.
              </p>
              <p>
                A impossibilidade de embarque gerada por falta de documentação adequada e exigida
                implicará no cancelamento da reserva e impossibilidade de embarque do Passageiro,
                sem que qualquer responsabilidade possa ser imputada ao Tudo Azul ou à Companhia
                Aérea operadora do voo, sendo aplicada a regra de não reembolsável (item 5).
              </p>
              <p>
                O Passageiro deverá cumprir com o previsto no Contrato de Transporte Aéreo da
                Companhia Operadora do Voo no que diz respeito, mas não somente, às regras de
                segurança.
              </p>
            </li>
            <li>
              <strong>RESPONSABILIDADES E OBRIGAÇÕES DO AZUL FIDELIDADE</strong>
              <p>
                O AZUL FIDELIDADE somente poderá ser responsabilizado nos termos de sua responsabilidade
                contratual, na forma dos limites legais dispostos nas legislações aplicáveis e
                específicas.
              </p>
              <p>
                Na ocorrência de alterações no Contrato de Transporte Aéreo, no que diz respeito aos
                horários ou datas dos voos originalmente contratados pelo Participante, caberá à
                Companhia Aérea operadora do voo comunicar previamente o AZUL FIDELIDADE para que este
                repasse tais informações ao Participante, desde que este tenha informado
                corretamente seus dados de contato no momento da emissão do Bilhete e cadastro do
                AZUL FIDELIDADE.
              </p>
            </li>
            <li>
              <strong>DA ASSISTÊNCIA MATERIAL E REACOMODAÇÃO EM VOOS</strong>
              <p>
                Para fatos ocorridos durante a execução do Contrato de Transporte Aéreo, o
                Passageiro deverá contatar a Companhia Aérea operadora do voo para que a mesma
                preste as informações e assistências cabíveis conforme a legislação aplicável.
              </p>
            </li>
            <li>
              <strong>FORO</strong>
              <p>
                Qualquer controvérsia oriunda do presente Contrato deverá ser dirimida perante o
                Foro da Comarca de Barueri - SP.
              </p>
            </li>
          </ol>
        </p>
      </span>
    );
  }
}

TaxRules.propTypes = propTypes;

export default TaxRules;



// WEBPACK FOOTER //
// ./src/components/flightSelection/taxRules/TaxRules.jsx